import React from 'react';
import { DataTable } from 'primereact/datatable';
import { Column } from 'primereact/column';
import { useLanguage } from '../../../../contexts/LanguageContext';

const STOCK_CONTROL_LABELS = {
    TR: { available: 'VAR', unavailable: 'YOK' },
    default: { available: 'In Stock', unavailable: 'Out of Stock' }
};

const stockControlTemplate = (rowData, currentLanguageId) => {
    const value = rowData.stockControl;
    if (!value) return '-';

    const isAvailable = value === 'VAR';
    const labels = currentLanguageId === 2 ? STOCK_CONTROL_LABELS.TR : STOCK_CONTROL_LABELS.default;

    return (
        <span className={`px-2 py-1 border-round text-xs font-semibold ${isAvailable ? 'bg-green-100 text-green-800' : 'bg-red-100 text-red-800'}`}>
            {isAvailable ? labels.available : labels.unavailable}
        </span>
    );
};

const MaterialCatalogOtherTable = ({ items, lazyParams, totalRecords, loading, onPage, th }) => {
    const { getCurrentLanguageId } = useLanguage();
    return (
        <DataTable
            value={items}
            lazy
            paginator
            first={lazyParams.first}
            rows={lazyParams.rows}
            onPage={onPage}
            totalRecords={totalRecords}
            loading={loading}
            emptyMessage={th('common.noData')}
            rowsPerPageOptions={[5, 10, 25, 50]}
            showGridlines
            stripedRows
            tableStyle={{ minWidth: '50rem' }}
        >
            <Column field="dealerCode" header={th('materialCatalog.dealerCode')} body={(rowData) => rowData.dealerCode ?? '-'} style={{ minWidth: '120px' }} />
            <Column field="dealerName" header={th('materialCatalog.dealerName')} body={(rowData) => rowData.dealerName ?? '-'} style={{ minWidth: '200px' }} />
            <Column field="partCode" header={th('materialCatalog.partCode')} body={(rowData) => rowData.partCode ?? '-'} style={{ minWidth: '150px' }} />
            <Column field="partDescription" header={th('materialCatalog.partDescription')} body={(rowData) => rowData.partDescription ?? '-'} style={{ minWidth: '200px' }} />
            <Column field="stockControl" header={th('materialCatalog.stockControl')} body={(rowData) => stockControlTemplate(rowData, getCurrentLanguageId())} />
        </DataTable>
    );
};

export default MaterialCatalogOtherTable;